module.exports = __webpack_public_path__ + "img/pin.27468be4.svg";